import { Component, Inject, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { AdminService } from "../admin.service";
import { MatSnackBar } from "@angular/material/snack-bar";
import { formatDate } from "@angular/common";
import { AdminTripsViewComponent } from "../admin-trips-view/admin-trips-view.component";

@Component({
  selector: "app-admin-cancel-trip",
  templateUrl: "./admin-cancel-trip.component.html",
  styleUrls: ["./admin-cancel-trip.component.css"],
})
export class AdminCancelTripComponent implements OnInit {
  actualAmountPaid = this.data.paymentInfo[0]?.price_details?.amount_paid;
  Reduction = this.actualAmountPaid * 0.02;
  partialpaid = this.actualAmountPaid - this.Reduction;
  partialRefund = Math.round(this.partialpaid);
  value: any;
  Others: any;
  paymentMode = "";
  amount_paid: any;
  reason: any;
  token: any;
  payment_Type: any;
  isCorporateUser: boolean = false;
  // trip_Obj: any = [
  //   {
  //     amount_paid: 0,
  //     payment_mode: "string",
  //     reason: "string",
  //   },
  // ];
  constructor(
    private service: AdminService,
    private matdialogref: MatDialogRef<AdminCancelTripComponent>,
    private matdialogre: MatDialogRef<AdminTripsViewComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private snackBar: MatSnackBar
  ) {
    this.value = formatDate(new Date(), "dd/MM/yyyy", "en-US");
  }

  ngOnInit(): void {
    this.token = localStorage.getItem("adminToken");
    this.isCorporateUser = this.data?.userInfo?.[0]?.user_type === "corporate";
  }
  close() {
    this.matdialogref.close();
  }
  onInput(event: any) {
    if (event.target.value > this.actualAmountPaid) {
      this.snackBar.open(
        "Entered amount should not be exceeded with Actual refund",
        "fail",
        {
          duration: 5000,
        }
      );
    } else {
      this.Others = event.target.value;
    }
  }
  selectLoadedQty(event: any) {
    this.payment_Type = "";
    this.amount_paid = "";
    if (event == "Fully-Refund") {
      this.amount_paid = Number(this.actualAmountPaid);
      this.payment_Type = event;
    } else if (event == "Partial-Refund") {
      this.amount_paid = Number(this.partialRefund);
      this.payment_Type = event;
    } else if (event == "Others-Refund") {
      this.amount_paid = this.Others;
      this.payment_Type = event;
    }
  }

  cancelTrip() {
    if (this.amount_paid == undefined) {
      this.amount_paid = this.Others;
    }
    if (this.isCorporateUser) {
      this.amount_paid = 0;
      this.payment_Type = "No-Refund";
    }
    const Object = {
      amount_paid: Number(this.amount_paid),
      payment_mode: this.paymentMode,
      reason: this.reason,
      payment_date: this.value,
      payment_type: this.payment_Type,
    };

    this.service.cancleTrip(Object, this.token, this.data._id).subscribe(
      (response: any) => {
        if (response.status == 200) {
          this.matdialogref.close();
          this.matdialogre.close();
          location.reload();
          this.snackBar.open(response.body?.message, "Success", {
            duration: 5000,
          });
        }
      },
      (error: any) => {
        this.snackBar.open(error.error?.message, "Fail", {
          duration: 5000,
        });
      }
    );
  }
}
